var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDribbble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97242 1.50684C4.43515 2.31676 3.10646 3.48062 2.09286 4.90509C1.07927 6.32955 0.408982 7.97499 0.135742 9.70948H0.77819C4.92087 9.61215 8.16855 9.24828 10.8211 8.42472C9.66908 6.35385 8.26307 4.32191 6.57647 2.25553L6.57499 2.25403L5.97242 1.50684Z",
    fill: "white",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00295378 11.2066L0 11.4761C0 14.4963 1.17561 17.238 3.08818 19.2565L3.32596 18.7713C3.33917 18.7445 3.35397 18.7185 3.37027 18.6934C5.81895 14.9171 8.5896 12.671 11.6881 11.6633C11.8978 11.5944 12.1105 11.5315 12.3232 11.4746C12.0751 10.898 11.8106 10.3287 11.5301 9.76758C8.628 10.7154 5.13958 11.1047 0.803429 11.2051H0.00443067L0.00295378 11.2066Z",
    fill: "white",
    fillOpacity: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22363 20.301C6.17506 21.8633 8.58993 22.7113 11.0764 22.7073C12.3953 22.7073 13.661 22.4737 14.8321 22.0454V20.9673C14.4718 18.0699 13.8382 15.412 12.8856 12.8755C12.6345 12.9384 12.3849 13.0103 12.1383 13.0896C9.4474 13.9656 6.93225 15.9391 4.6283 19.4804L4.22511 20.301H4.22363Z",
    fill: "white",
    fillOpacity: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3093 21.3768C17.737 20.6001 18.9795 19.5157 19.9496 18.2C20.9197 16.8843 21.5938 15.3692 21.9245 13.7611L21.09 13.3793C18.6886 12.6635 16.4511 12.37 14.3657 12.6081C15.308 15.1836 15.9416 17.8879 16.3034 20.8257C16.3078 20.8557 16.3093 20.8856 16.3093 20.9186V21.3768Z",
    fill: "white",
    fillOpacity: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1293 12.213C22.3243 9.27164 21.3662 6.37118 19.4635 4.14209L19.0249 4.63473C17.2969 6.7655 15.3238 8.24341 12.9253 9.24965C13.2384 9.88454 13.5308 10.5239 13.8011 11.1723C16.2705 10.8129 18.8668 11.1513 21.5562 11.9584C21.589 11.9681 21.6211 11.9801 21.6522 11.9943L22.1293 12.213Z",
    fill: "white",
    fillOpacity: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.426 3.07316C16.4016 1.24824 13.7859 0.242011 11.077 0.246106C9.78032 0.246106 8.53678 0.470713 7.38037 0.886984L7.7171 1.30326C9.51891 3.50889 11.0135 5.68908 12.2334 7.91867C14.5123 6.98581 16.3185 5.6217 17.8958 3.67061C17.903 3.66144 17.9104 3.65246 17.918 3.64366L18.426 3.07465V3.07316Z",
    fill: "white",
    fillOpacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbble);
export default __webpack_public_path__ + "static/media/dribbble.73148b97233e2459133846dbaa778e73.svg";
export { ForwardRef as ReactComponent };